import { useScrollReveal } from '@/hooks/useScrollReveal';
import { amenitiesList } from '@/mocks/landingData';

export default function Amenities() {
  useScrollReveal('.amenities-reveal', 0.1);

  return (
    <section id="amenities" className="py-10 md:py-16 bg-cream">
      <div className="section-padding">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-12">
          <div className="amenities-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/5 border border-primary/10 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-primary">
              <span className="w-1.5 h-1.5 bg-gold rounded-full" />
              Amenities
            </span>
          </div>
          <h2 className="amenities-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl text-charcoal font-bold mt-4 md:mt-5 leading-tight">
            Lifestyle <span className="text-gradient-gold">Amenities</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 md:gap-4 max-w-4xl mx-auto">
          {amenitiesList.map((amenity, index) => (
            <div
              key={amenity.name}
              className="amenities-reveal scroll-reveal group bg-white rounded-2xl p-4 md:p-6 text-center border border-cream-dark/50 hover:border-gold transition-all duration-500 hover:-translate-y-1 hover:shadow-lg hover:shadow-gold/5"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary/5 flex items-center justify-center mx-auto mb-2.5 md:mb-3 group-hover:bg-gold/10 transition-colors duration-500 border border-transparent group-hover:border-gold/30">
                <i className={`${amenity.icon} text-primary text-base md:text-xl group-hover:text-gold transition-colors duration-500`}></i>
              </div>
              <h3 className="font-body text-[11px] md:text-sm text-charcoal font-semibold leading-tight">{amenity.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}